interface CarouselItem {
  id: number;
  title: string;
  desc: string;
  tag: string;
  imageUrl: string;
  imageAlt: string;
}

const carouselItems: CarouselItem[] = [
  {
    id: 1,
    title: '斗破苍穹：萧炎决战魂天帝',
    desc: '年度最震撼决战篇章，斗气化翼燃爆苍穹。下拉式阅读完整剧情一气呵成，每一页都是壁纸级的视觉盛宴。',
    tag: '🔥 热播中',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20manga%20style%20illustration%2C%20dramatic%20battle%20scene%20with%20flying%20character%20and%20energy%20effects%2C%20warm%20coral%20and%20golden%20amber%20lighting%2C%20watercolor%20ink%20artistic%20style%2C%20powerful%20dynamic%20composition%2C%20soft%20gradient%20background%20with%20clouds%2C%20high%20detail%2C%20shonen%20manga%20aesthetic&width=1000&height=600&seq=carousel-manga-01&orientation=landscape',
    imageAlt: '香香漫画 - 斗破苍穹精选专题',
  },
  {
    id: 2,
    title: '一人之下：异人世界全解析',
    desc: '从罗天大醮到唐门篇，全面解读异人世界的精彩设定与人物关系。香香漫画免费下拉畅读全系列。',
    tag: '⭐ 热门推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Martial%20arts%20manga%20style%20illustration%2C%20dynamic%20character%20with%20flowing%20robes%20and%20energy%20aura%2C%20warm%20amber%20and%20deep%20coral%20tones%2C%20traditional%20Chinese%20ink%20painting%20artistic%20style%2C%20dramatic%20composition%20with%20wind%20effects%2C%20soft%20mountain%20background%2C%20high%20detail%2C%20seinen%20manga%20aesthetic&width=1000&height=600&seq=carousel-manga-02&orientation=landscape',
    imageAlt: '香香漫画 - 一人之下精选专题',
  },
  {
    id: 3,
    title: '咒术回战：领域展开名场面',
    desc: '盘点咒术回战中所有领域展开的震撼瞬间，从无量空处到伏魔御厨子，每一帧都是艺术品。',
    tag: '💥 话题热议',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20supernatural%20manga%20style%20illustration%2C%20dramatic%20scene%20with%20mystical%20energy%20domain%20expansion%20effect%2C%20warm%20coral%20and%20amber%20accents%20with%20deep%20shadows%2C%20watercolor%20ink%20artistic%20style%2C%20powerful%20composition%20with%20glowing%20elements%2C%20soft%20dark%20gradient%20background%2C%20high%20detail%2C%20seinen%20manga%20aesthetic&width=1000&height=600&seq=carousel-manga-03&orientation=landscape',
    imageAlt: '香香漫画 - 咒术回战精选专题',
  },
  {
    id: 4,
    title: '恋爱漫画特辑：怦然心动瞬间',
    desc: '精选最甜蜜的恋爱心动名场面合集，从初遇到告白，每一段青春恋曲都值得被珍藏。下拉畅读甜到心里。',
    tag: '💕 甜蜜推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20shojo%20manga%20style%20illustration%2C%20beautiful%20scene%20with%20cherry%20blossoms%20and%20soft%20spring%20light%2C%20warm%20coral%20rose%20and%20gentle%20pink%20tones%2C%20watercolor%20artistic%20style%2C%20dreamy%20atmosphere%2C%20clean%20harmonious%20composition%2C%20soft%20gradient%20background%2C%20high%20detail%2C%20shojo%20manga%20aesthetic&width=1000&height=600&seq=carousel-manga-04&orientation=landscape',
    imageAlt: '香香漫画 - 恋爱漫画精选专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1300px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">编辑团队为你深度策划的漫画专题合集</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full aspect-[5/3] object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-950/70 text-background-50 text-xs font-medium rounded-full backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
                <span className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium mt-3 cursor-pointer whitespace-nowrap">
                  立即阅读 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}